import React from 'react'

import * as S from './Hero.style'
import FormContainer from './FormContainer/FormContainer'

const Hero = () => {
  const isTitlePresent = global.showNextoriesNewTitle !== undefined
  const title = global.showNextoriesNewTitle
    ? `Comparez et économisez jusqu'à 30% sur votre déménagement`
    : `Trouvez votre déménageur professionnel au meilleur prix avec Nextories`
  return (
    <S.Wrapper>
      <S.Content>
        {isTitlePresent ? <S.Title>{title}</S.Title> : <S.Title />}
        <FormContainer />
      </S.Content>
    </S.Wrapper>
  )
}

export default Hero
